import React from "react";
import TableGrid from "../../../CommonComponents/TableGridView/TableGrid";
import classes from "./Investigation.module.css";
import InvestigationAssignedBlock from "./InvestigationAssignedBlock";
import InvestigatorDetails from "./InvestigatorDetails";
import { RandomBoxShadows } from "../../../constants/approvalInvoicesSampleData";
import PropTypes from "prop-types";

const InvestigatorsTab = ({
  indexOfInvestigatorsDeatilsArray,
  InvestigationAssignedBlockValueArray = [],
  InvestigationAssignedBlockClickHandler = () => {},
  onUploadButtonClickHandler = () => {},
  ApprovalInvestigationAssignedBlocks = [],
  InvestigatorTabDetails = [],
  ApprovalInvestigationAssignedBlocksContents = [],
}) => {
  const getLabelById = (id) => {
    const block = ApprovalInvestigationAssignedBlocks.find(
      (item) => item.id == id
    );
    return block ? block?.label : "";
  };

  return (
    <div className={classes["investigators-tab-main-container"]}>
      <div>
        <InvestigatorDetails
          indexOfInvestigatorsDeatilsArray={indexOfInvestigatorsDeatilsArray}
          InvestigatorTabDetails={InvestigatorTabDetails}
        />
      </div>
      <div className={classes["investigation-assigned-block-container"]}>
        <InvestigationAssignedBlock
          InvestigationAssignedBlockClickHandler={
            InvestigationAssignedBlockClickHandler
          }
          ApprovalInvestigationAssignedBlocks={
            ApprovalInvestigationAssignedBlocks
          }
          InvestigatorTabDetails={InvestigatorTabDetails}
        />
      </div>
      {Object.keys(InvestigationAssignedBlockValueArray)?.length
        ? Object.keys(InvestigationAssignedBlockValueArray)?.map(
            (blockId, index) => {
              const item = InvestigationAssignedBlockValueArray[blockId];
              const label = getLabelById(blockId);
              // const label = ;
              const document = item && item?.documents?.length > 0;

              return (
                <div
                  className={
                    classes["investigation-assigned-block-bottom-container"]
                  }
                  key={blockId}
                >
                  <TableGrid
                    xs={3}
                    label="Upload Documents"
                    boxShadow={RandomBoxShadows[index]}
                    InvestigationLabel={label}
                    gridContent={item}
                    isDocument={document ? true : false}
                    documentDetails={item?.documents}
                    isVendorBlock={true}
                  />
                </div>
              );
            }
          )
        : null}
    </div>
  );
};

InvestigatorsTab.propTypes = {
  indexOfInvestigatorsDeatilsArray: PropTypes.number,
  InvestigationAssignedBlockValueArray: PropTypes.array,
  InvestigationAssignedBlockClickHandler: PropTypes.func,
};

export default InvestigatorsTab;
